/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import PropTypes from 'prop-types';
import React from 'react';

const MobileDrawerMenu = ({
    isOpen,
    visibleLinks,
    overflowLinks,
    closeDrawer,
    moreLabel,
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <>
            {/* Overlay */}
            <div
                className="mobile-drawer-overlay"
                onClick={closeDrawer}
            />

            {/* Drawer */}
            <div className="mobile-drawer">
                <button
                    className="close-button"
                    onClick={closeDrawer}
                >
                    ✕
                </button>

                <ul className="mobile-drawer-links">
                    {visibleLinks.map((link, i) => (
                        <li
                            key={`visible-${i}`}
                            onClick={closeDrawer}
                        >
                            {link}
                        </li>
                    ))}

                    {overflowLinks.length > 0 && (
                        <li className="sub-header">
                            {moreLabel}
                        </li>
                    )}

                    {overflowLinks.map((link, i) => (
                        <li
                            key={`overflow-${i}`}
                            className="subheader-link"
                            onClick={closeDrawer}
                        >
                            {link}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

MobileDrawerMenu.propTypes = {
    closeDrawer: PropTypes.func,
    isOpen: PropTypes.bool,
    moreLabel: PropTypes.string,
    overflowLinks: PropTypes.array,
    visibleLinks: PropTypes.array,
};

MobileDrawerMenu.defaultProps = {
    isOpen: false,
    visibleLinks: [],
    overflowLinks: [],
    closeDrawer: () => void 0,
    moreLabel: '',
};

export default React.memo(MobileDrawerMenu);
